import {
  Card,
  Button,
  Empty,
  Space,
  Typography,
  Checkbox,
  Divider,
  Input,
} from "antd";

import {
  PlusOutlined,
  CloseOutlined,
} from "@ant-design/icons";

import DayCard from "./DayCard";

const { Title, Text } =
  Typography;

const QuoteTimeline = ({
  lead,
  days = [],
  addDay,
  removeDay,
  updateDay,

  globalTransportConfig,
  vehicleOptions = [],

  quotationSettings,

  setQuotationSettings,

  companySettings,
  onOpenActivitySearch,
  searchHotels,
}) => {

  /* =====================================
     INCLUSIONS
  ===================================== */

  const addInclusion = () => {

    setQuotationSettings({

      ...quotationSettings,

      inclusions: [

        ...(quotationSettings
          ?.inclusions || []),

        "",
      ],
    });
  };

  const updateInclusion = (
    index,
    value
  ) => {

    const updated = [
      ...(quotationSettings
        ?.inclusions || []),
    ];

    updated[index] = value;

    setQuotationSettings({

      ...quotationSettings,

      inclusions: updated,
    });
  };

  const removeInclusion = (
    index
  ) => {

    const updated =
      (
        quotationSettings
          ?.inclusions || []
      ).filter(
        (_, i) => i !== index
      );

    setQuotationSettings({

      ...quotationSettings,

      inclusions: updated,
    });
  };

  /* =====================================
     EXCLUSIONS
  ===================================== */

  const addExclusion = () => {

    setQuotationSettings({

      ...quotationSettings,

      exclusions: [

        ...(quotationSettings
          ?.exclusions || []),

        "",
      ],
    });
  };

  const updateExclusion = (
    index,
    value
  ) => {

    const updated = [
      ...(quotationSettings
        ?.exclusions || []),
    ];

    updated[index] = value;

    setQuotationSettings({

      ...quotationSettings,

      exclusions: updated,
    });
  };

  const removeExclusion = (
    index
  ) => {

    const updated =
      (
        quotationSettings
          ?.exclusions || []
      ).filter(
        (_, i) => i !== index
      );

    setQuotationSettings({

      ...quotationSettings,

      exclusions: updated,
    });
  };

  return (

    <div>

      {days.length === 0 ? (

        <Card
          style={{
            borderRadius: 14,
          }}
        >

          <Empty
            description="No itinerary days added"
          />

        </Card>

      ) : (

        days.map((day, index) => (

          <DayCard
            key={day.id}

            lead={lead}

            day={day}

            dayNumber={index + 1}

            removeDay={removeDay}

            updateDay={updateDay}

            globalTransportConfig={
              globalTransportConfig
            }
            vehicleOptions={vehicleOptions}
            onOpenActivitySearch={onOpenActivitySearch}
            searchHotels={searchHotels}
          />

        ))
      )}

      {/* =====================================
         ADD DAY
      ===================================== */}

      <Card
        style={{
          marginTop: 16,
          borderRadius: 18,
          border:
            "1px dashed #cbd5e1",
          textAlign: "center",
          background:
            "linear-gradient(135deg,#ffffff 0%,#f8fbff 100%)",

          boxShadow:
            "0 8px 24px rgba(15,23,42,0.04)",
        }}
      >

        <Button
          type="dashed"
          icon={<PlusOutlined />}
          size="large"
          onClick={addDay}
          style={{
            borderRadius: 12,
            height: 48,
            paddingInline: 24,
            fontWeight: 700,
          }}
        >
          Add Day
        </Button>

      </Card>

      {/* =====================================
         INCLUSIONS & EXCLUSIONS
      ===================================== */}

      <Card
        style={{
          marginTop: 24,

          borderRadius: 24,

          border:
            "1px solid #e2e8f0",

          boxShadow:
            "0 10px 30px rgba(15,23,42,0.05)",
        }}
      >

        <Title
          level={4}
          style={{
            marginBottom: 24,
            fontWeight: 800,
            color: "#0f172a",
          }}
        >
          Inclusions & Exclusions
        </Title>

        <Text
          type="secondary"
          style={{
            display: "block",
            marginBottom: 24,
            fontSize: 15,
          }}
        >
          Configure all package inclusions and exclusions
          shown in the final quotation PDF.
        </Text>

        {/* =========================
           INCLUSIONS
        ========================= */}

        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >

          <Title
            level={5}
            style={{
              margin: 0,
              color: "#16a34a",
              fontWeight: 800,
            }}
          >
            ✅ Inclusions
          </Title>

          <Button
            type="dashed"
            size="small"
            icon={<PlusOutlined />}
            onClick={addInclusion}
            style={{
              borderRadius: 10,
              fontWeight: 700,
            }}
          >
            Add
          </Button>

        </div>

        {(quotationSettings
          ?.inclusions || [])
          .map(
            (
              inclusion,
              index
            ) => (

            <Space
              key={index}
              style={{
                display: "flex",
                marginBottom: 12,
              }}
            >

              <Input
                value={inclusion}

                placeholder="Enter inclusion"

                style={{
                  borderRadius: 12,
                  minHeight: 42,
                }}

                onChange={(e) =>
                  updateInclusion(
                    index,
                    e.target.value
                  )
                }
              />

              <Button
                danger

                icon={
                  <CloseOutlined />
                }

                style={{
                  borderRadius: 10,
                }}

                onClick={() =>
                  removeInclusion(
                    index
                  )
                }
              />

            </Space>
          ))}

        <Divider />

        {/* =========================
           EXCLUSIONS
        ========================= */}

        <div
          style={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >

          <Title
            level={5}
            style={{
              margin: 0,
              color: "#dc2626",
              fontWeight: 800,
            }}
          >
            ❌ Exclusions
          </Title>

          <Button
            type="dashed"
            size="small"
            icon={<PlusOutlined />}
            onClick={addExclusion}
            style={{
              borderRadius: 10,
              fontWeight: 700,
            }}
          >
            Add
          </Button>

        </div>

        {(quotationSettings
          ?.exclusions || [])
          .map(
            (
              exclusion,
              index
            ) => (

            <Space
              key={index}
              style={{
                display: "flex",
                marginBottom: 12,
              }}
            >

              <Input
                value={exclusion}

                placeholder="Enter exclusion"

                style={{
                  borderRadius: 12,
                  minHeight: 42,
                }}

                onChange={(e) =>
                  updateExclusion(
                    index,
                    e.target.value
                  )
                }
              />

              <Button
                danger

                icon={
                  <CloseOutlined />
                }

                style={{
                  borderRadius: 10,
                }}

                onClick={() =>
                  removeExclusion(
                    index
                  )
                }
              />

            </Space>
          ))}

      </Card>

      {/* =====================================
         POLICIES & TERMS
      ===================================== */}

      <Card
        style={{
          marginTop: 24,

          borderRadius: 24,

          border:
            "1px solid #e2e8f0",

          boxShadow:
            "0 10px 30px rgba(15,23,42,0.05)",
        }}
      >

        <Title
          level={4}
          style={{
            marginBottom: 24,
            fontWeight: 800,
            color: "#0f172a",
          }}
        >
          Policies & Terms
        </Title>

        {/* =========================
           TERMS
        ========================= */}

        <Checkbox
          checked={
            quotationSettings
              ?.includeTerms
          }
          onChange={(e) =>
            setQuotationSettings({

              ...quotationSettings,

              includeTerms:
                e.target.checked,
            })
          }
        >
          Terms & Conditions
        </Checkbox>

        {quotationSettings
          ?.includeTerms && (

          <Card
            size="small"
            style={{
              marginTop: 12,

              background:
                "linear-gradient(135deg,#f8fbff 0%,#eef4ff 100%)",

              border:
                "1px solid #dbeafe",

              borderRadius: 16,
            }}
          >

            <Text
              style={{
                whiteSpace:
                  "pre-wrap",

                lineHeight: 1.9,
              }}
            >

              {


companySettings
  ?.termsAndConditions
  ?.content ||

                "No terms configured"

              }

            </Text>

          </Card>
        )}

        <Divider />

        {/* =========================
           PAYMENT POLICY
        ========================= */}

        <Checkbox
          checked={
            quotationSettings
              ?.includePaymentPolicy
          }
          onChange={(e) =>
            setQuotationSettings({

              ...quotationSettings,

              includePaymentPolicy:
                e.target.checked,
            })
          }
        >
          Payment Policy
        </Checkbox>

        {quotationSettings
          ?.includePaymentPolicy && (

          <Card
            size="small"
            style={{
              marginTop: 12,

              background:
                "linear-gradient(135deg,#f8fbff 0%,#eef4ff 100%)",

              border:
                "1px solid #dbeafe",

              borderRadius: 16,
            }}
          >

            <Text
              style={{
                whiteSpace:
                  "pre-wrap",

                lineHeight: 1.9,
              }}
            >

              {

companySettings
  ?.paymentPolicy ||

                "No payment policy configured"

              }

            </Text>

          </Card>
        )}

        <Divider />

        {/* =========================
           CANCELLATION POLICY
        ========================= */}

        <Checkbox
          checked={
            quotationSettings
              ?.includeCancellationPolicy
          }
          onChange={(e) =>
            setQuotationSettings({

              ...quotationSettings,

              includeCancellationPolicy:
                e.target.checked,
            })
          }
        >
          Cancellation Policy
        </Checkbox>

        {quotationSettings
          ?.includeCancellationPolicy && (

          <Card
            size="small"
            style={{
              marginTop: 12,

              background:
                "linear-gradient(135deg,#f8fbff 0%,#eef4ff 100%)",

              border:
                "1px solid #dbeafe",

              borderRadius: 16,
            }}
          >

            <Text
              style={{
                whiteSpace:
                  "pre-wrap",

                lineHeight: 1.9,
              }}
            >

              {

companySettings
  ?.refundPolicy ||

                "No cancellation policy configured"

              }

            </Text>

          </Card>
        )}

      </Card>

    </div>
  );
};

export default QuoteTimeline;
